// import SVG from 'react-inlinesvg';
import classNames from "classnames";
import React from "react";
import Modal from "react-modal";
import { FORM_FIELD_SUBMIT_CLASS_NAME } from "tsi-common-react/src/forms/classNames";
import { t } from "ttag";

import { richT } from "@thelabnyc/thelabui/src/utils/richText";

interface IProps {
    isOpen: boolean;
    isSubmitting: boolean;
    onClose: () => void;
    onSubmit: (data: { rating: number | null }) => void;
}

const possibleRatings = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const SurveyModalRateWebsite = (props: IProps): React.ReactNode => {
    const [rating, setRating] = React.useState<number | null>(null);

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        props.onSubmit({
            rating: rating,
        });
    };

    const buildRatings = () => {
        const elems = possibleRatings.map((ratingValue) => {
            const classes = classNames({
                "br-current": rating === ratingValue,
            });
            // TODO(i18n): Wrap screen reader text in t tagged template: {t`This element is selected`}
            const screenReaderText =
                rating === ratingValue ? (
                    <span className="ada-screenreader-only">
                        This element is selected
                    </span>
                ) : null;
            return (
                <a
                    key={ratingValue}
                    data-rating-value={ratingValue}
                    data-rating-text={ratingValue}
                    className={classes}
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        setRating(ratingValue);
                    }}
                >
                    {screenReaderText}
                    {ratingValue}
                </a>
            );
        });
        return elems;
    };

    return (
        <Modal
            aria={{
                modal: true,
            }}
            style={{
                content: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxHeight: "95%",
                    maxWidth: "542px",
                    width: "96%",
                    overflow: "auto",
                    padding: "40px",
                },
            }}
            // TODO(i18n): Translate contentLabel attribute with t tagged template: contentLabel={t`Survey`}
            contentLabel="Survey"
            portalClassName="locator"
            className="locations store-locator-survey modal"
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            role="dialog"
        >
            <div className="modal-inner">
                <div
                    aria-label={t`Close`}
                    className="modal-close button--ghost"
                    onClick={props.onClose}
                >
                    <div className="pdp-modal__close-icon modal-close__icon"></div>
                </div>
                <div className="send__content survey__carousel">
                    <h3>{richT(t`Your directions<br />are on the way…`)}</h3>
                    <p className="modal-intro">
                        {t`One quick question. How was your online experience today?`}
                    </p>
                    <form onSubmit={onSubmit}>
                        <fieldset>
                            {/* TODO(i18n): Wrap legend text in t tagged template: {t`Rate your experience`} */}
                            <legend className="ada-screenreader-only">
                                Rate your experience
                            </legend>
                            <div className="br-wrapper br-theme-bars-square">
                                <div className="br-widget">
                                    {buildRatings()}
                                </div>
                            </div>
                            <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                                {/* TODO(i18n): Translate value attribute with t tagged template: value={t`Continue`} */}
                                <input
                                    id="survey-cell2-submit-email"
                                    type="submit"
                                    value="Continue"
                                    className="button al-store-locator__button--continue"
                                    disabled={!rating}
                                />
                            </div>
                        </fieldset>
                    </form>
                </div>
            </div>
        </Modal>
    );
};
